import { render, staticRenderFns } from "./WordOfTheDayCard.vue?vue&type=template&id=2ef2c686&scoped=true"
import script from "./WordOfTheDayCard.vue?vue&type=script&lang=js"
export * from "./WordOfTheDayCard.vue?vue&type=script&lang=js"
import style0 from "./WordOfTheDayCard.vue?vue&type=style&index=0&id=2ef2c686&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef2c686",
  null
  
)

export default component.exports